import axios from 'axios';
import { authHeaders } from './authHeaders';
import { SuscriptorResponse } from '../types/Suscriptor';

/**
 * API base URL
 */
const API_URL = '/api/suscriptor';

/**
 * Servicio para consumir la API de suscriptores
 */
const suscriptorService = {
  /**
   * Consulta un suscriptor por SourceSystemID
   * @param sourceSystemId - ID del sistema fuente
   * @returns Respuesta con datos del suscriptor
   */
  async getSuscriptorBySourceSystemId(sourceSystemId: string): Promise<SuscriptorResponse> {
    try {
      const response = await axios.get(`${API_URL}/sourceSystemId/${sourceSystemId}`, {
        headers: authHeaders()
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // Error con respuesta del servidor. El 404 se marca aparte: es
        // "no existe", no "falló la consulta".
        return {
          ...(error.response.data as SuscriptorResponse),
          notFound: error.response.status === 404,
        };
      } else {
        // Error sin respuesta o de otro tipo
        return {
          success: false,
          message: 'Error al consultar el suscriptor',
          error: error instanceof Error ? error.message : 'Error desconocido'
        };
      }
    }
  },

  /**
   * Consulta un suscriptor por tipo y número de documento
   * @param tipoDoc - Tipo de documento
   * @param numDoc - Número de documento
   * @returns Respuesta con datos del suscriptor
   */
  async getSuscriptorByDocumento(tipoDoc: string, numDoc: string): Promise<SuscriptorResponse> {
    try {
      const response = await axios.get(`${API_URL}/documento/${tipoDoc}/${numDoc}`, {
        headers: authHeaders()
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // Error con respuesta del servidor. El 404 se marca aparte: es
        // "no existe", no "falló la consulta".
        return {
          ...(error.response.data as SuscriptorResponse),
          notFound: error.response.status === 404,
        };
      } else {
        // Error sin respuesta o de otro tipo
        return {
          success: false,
          message: 'Error al consultar el suscriptor',
          error: error instanceof Error ? error.message : 'Error desconocido'
        };
      }
    }
  }
};

export default suscriptorService; 